import {Form, Input} from "antd";
import React, {useState} from "react";

const RenderInput = ({form, name, placeholder, message, label, required }) => {

    const [check, setCheck] = useState(true)

    return (
        <Form.Item
            label={label}
            name={name}
            rules={[
                {
                    required: required,
                    message: message
                },
            ]}
        >
            <Input placeholder={placeholder}
                   onChange={(e) => {
                       let value = e.target.value
                       if (check) {
                           form.setFieldValue(name, value.charAt(0).toUpperCase() + value.slice(1))
                           if (value) setCheck(false)
                       }
                   }}/>
        </Form.Item>
    )
}

export default RenderInput
